import { useQuery } from "@tanstack/react-query";
import ActivityFeed from "../../../../../components/ActivityFeed/ActivityFeed.js";
import { AnalysisAPI } from "../../../../../api/index.js";
import styled from "styled-components";

const TraceIndicatorActivity = styled(({ className, defaultData }) => {
  const { data, isLoading } = useQuery({
    queryKey: [
      "analysis",
      "logs",
      "list",
      { uuid: defaultData.uuid, object_type: "trace_indicator" },
    ],
    queryFn: ({ queryKey }) => {
      const [, , , query] = queryKey;
      return AnalysisAPI.Logs.get(query);
    },
    enabled: !!defaultData.uuid,
  });

  const logs = (data?.data || []).reverse();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className={className}>
      <ActivityFeed logs={logs} />
    </div>
  );
})`
  margin-top: 15px;

  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 0px;
`;

export default TraceIndicatorActivity;
